import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/episodes", label: "剧集" },
  { to: "/characters", label: "角色" },
  { to: "/news", label: "资讯" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur-md border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-lg md:text-xl">
              公
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-wide">
                公公与儿媳
              </span>
              <span className="text-[10px] md:text-xs text-foreground-500 tracking-widest mt-0.5">
                家庭剧 · 剧情资料站
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-700 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/search"
              aria-label="搜索"
              className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-xl" />
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <nav className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-base font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-700 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/search"
              className="px-4 py-3 rounded-md text-base font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer flex items-center gap-2"
            >
              <i className="ri-search-line text-lg" />
              搜索剧情
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}